export default "__VITE_ASSET__c2761586__"